export default __webpack_public_path__ + "static/press-release-radevormwald-68d275b06bbc2dfb016c83e3e6b87668.jpg";